import React, { useEffect, useState, useRef } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { handleCognitoCallback } from '../auth/cognito';
import { useAuth } from '../auth/AuthContext';

export default function AuthCallbackPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { setTokens } = useAuth();
  const processedRef = useRef(false);

  const [status, setStatus] = useState('Signing you in…');
  const [error, setError] = useState('');

  useEffect(() => {
    const run = async () => {
      if (processedRef.current) return;
      processedRef.current = true;

      const errorFromCognito = searchParams.get('error');
      const errorDescription = searchParams.get('error_description');
      if (errorFromCognito) {
        setError(errorDescription || errorFromCognito);
        setStatus('Sign-in failed');
        return;
      }

      try {
        const code = searchParams.get('code');
        const state = searchParams.get('state');
        const { tokens, nextPath } = await handleCognitoCallback({ code, state });
        setTokens(tokens);
        navigate(nextPath || '/', { replace: true });
      } catch (e) {
        setError(e instanceof Error ? e.message : String(e));
        setStatus('Sign-in failed');
      }
    };

    run();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="auth-page">
      <div className="card">
        <h1>{status}</h1>
        {error ? (
          <>
            <div className="alert alert-error">{error}</div>
            <Link className="btn btn-secondary" to="/login">
              Back to sign in
            </Link>
          </>
        ) : (
          <p className="muted">Please wait…</p>
        )}
      </div>
    </div>
  );
}

